// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__dbR3C","logo":"Navbar_logo__l1Z_s","img":"Navbar_img__GrHI1","text":"Navbar_text__eBXpg","items":"Navbar_items__W_qZc","item":"Navbar_item___WiCN"};